const legacyKey = 'wordcraft.gameId';
const languagePrefix = `${legacyKey}.`;

export function createSavedGames(storage) {
  return {
    get(languageCode) { return storage.getItem(`${languagePrefix}${languageCode}`); },
    legacy() { return storage.getItem(legacyKey); },
    remember(game) {
      storage.setItem(`${languagePrefix}${game.language.code}`, game.id);
      storage.setItem(legacyKey, game.id);
    },
    forget(languageCode, gameId) {
      const key = `${languagePrefix}${languageCode}`;
      if (storage.getItem(key) === gameId) storage.removeItem(key);
      if (storage.getItem(legacyKey) === gameId) storage.removeItem(legacyKey);
    },
    clear() {
      for (let index = storage.length - 1; index >= 0; index--) {
        const key = storage.key(index);
        if (key === legacyKey || key?.startsWith(languagePrefix)) storage.removeItem(key);
      }
    }
  };
}
